import angular from "angular";
import OdpocetFormCtrl from "./OdpocetFormCtrl";
import OdpocetListCtrl from "./OdpocetListCtrl";
import SamoodpocetService from "./SamoodpocetService";

export default angular
.module("energis.odpocet", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("odpocet-list", {
    url: "/odpocet/zoznam",
    template: require("./odpocet.list.html"),
    controller: OdpocetListCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemSource: SamoodpocetService => SamoodpocetService.listSource().wait()
    }
  })
  .state("odpocet", {
    url: "/odpocet/zadanie",
    template: require("./odpocet.form.html"),
    controller: OdpocetFormCtrl,
    controllerAs: "ctrl",
    resolve: {
    }
  })
})
.service("SamoodpocetService", SamoodpocetService)
.name;



// WEBPACK FOOTER //
// ./src/Odpocet/index.js